import React from 'react'
import styles from './styles.module.css'

interface IActionsProps {
  children?: React.ReactNode
}

export const Actions = ({ children }: IActionsProps) => {
  return <div className={styles.actions}>{children}</div>
}
